import React, { useState } from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Space,
  Image,
} from 'antd';
import moment from 'moment';
import { QuestionCircleOutlined  } from '@ant-design/icons';
import * as Config from '../../../appConfig';
import { activePeriod, disabledDate, isSunday } from '../../../utils/date';

const AddIncentiveImportForm = ({
  portfolios,
  onIncentiveImportSubmit,
  onCancelClick,
  UploadFile,
  ability,
}) => {
  const [form] = Form.useForm();
  const [freezePrevMonth, currentMonth, prevMonth] = activePeriod();
  const [showTemplate, setShowTemplate] = useState(false);

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        size="large"
        className="ant-form-custom"
        initialValues={{}}
        onFinish={(values) =>
          onIncentiveImportSubmit(values, (updated) => {
            if (updated.status === 2) {
              // setShowRelieveModal(false);
            }
          })
        }
        style={{ marginTop: '0' }}
      >
        <Row>
          <Col xs={24} md={14}>
            <Form.Item
              label="Portfolio"
              name="portfolio_id"
              rules={[
                {
                  required: true,
                  message: 'Please select Portfolio!',
                },
              ]}
            >
              <Select placeholder="Please select" style={{ width: '80%' }}>
                {portfolios &&
                  portfolios.map((portfolio) => (
                    <Select.Option key={portfolio.id} value={portfolio.id}>
                      {portfolio.name} ({portfolio.code})
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={10}>
            <Form.Item
              label="Month"
              name="for_month"
              rules={[
                {
                  required: true,
                  message: 'Please select Month!',
                },
              ]}
            >
              <DatePicker
                disabledDate={(current) =>
                  disabledDate(
                    current,
                    freezePrevMonth,
                    currentMonth,
                    prevMonth
                  ) || isSunday(current)
                }
                format={Config.DATE_MONTH_INPUT}
                picker="month"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Form.Item label="Note" name="note">
              <Input placeholder="Note" maxLength="255" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>{UploadFile}</Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Button
              type="link"
              size="small"
              onClick={() => setShowTemplate(true)}
              icon={<QuestionCircleOutlined  />}
            >
              Incentive import template
            </Button>
            <Image
              width={200}
              style={{ display: 'none' }}
              src={process.env.PUBLIC_URL + '/import-templates/incentives.png'}
              preview={{
                visible: showTemplate,
                src:
                  process.env.PUBLIC_URL + '/import-templates/incentives.png',
                onVisibleChange: (value) => {
                  setShowTemplate(value);
                },
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={24} align="right">
            <Space>
              <Button type="secondary" size="middle" onClick={onCancelClick}>
                Cancel
              </Button>
              <Button type="primary" size="middle" htmlType="submit">
                Import
              </Button>
            </Space>
          </Col>
        </Row>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
      </Form>
    </>
  );
};

export default AddIncentiveImportForm;
